import SiteContext from "../context/SiteContext";
import {useContext} from "react";
import IndustryNavigator from "./IndustryNavigator";
import IndustryChatDemo from "./IndustryChatDemo";
import {useEffect} from "react";
import SiteMenu from "../layout/SiteMenu";

const IndustryContainer = () => {

    const {industries, currentIndustryIndex, fetchData, setMenuOpen} = useContext(SiteContext);

    useEffect(() => {

        fetchData();
        return () => {

        }
    }, [industries, fetchData])




        if(industries.length > 0){
            const currentIndustry = industries[currentIndustryIndex]?.id;
            return <div className="site-wrapper" onPointerDown={() => setMenuOpen(false)}>
                <SiteMenu/>
                {currentIndustry &&
                    <div className={`industry-container`}>
                        {industries.length > 1 && <IndustryNavigator/>}
                        <IndustryChatDemo/>
                        {industries.map((industry, index) => {
                            return <img alt={industry.id} key={index} className={`industry-container-bkg ${industry.id === currentIndustry?'selected':''}`} src={industries[currentIndustryIndex].bkg_image}/>
                        })}
                    </div>
                }
            </div>

        }else{
            return <span></span>
        }


};

export default IndustryContainer;
